import Marquee from "react-fast-marquee";
import { useLang } from "@/lib/LanguageContext";

export default function EditorialMarquee() {
    const { t } = useLang();
    const items = t("marquee");
    const list = Array.isArray(items) ? items : [];
    return (
        <section
            className="relative border-y border-[#D9D1C7] bg-[#EBE5DA] py-8 md:py-10 overflow-hidden"
            data-testid="editorial-marquee"
        >
            <Marquee speed={28} gradient={false} pauseOnHover={false}>
                {list.map((label, i) => (
                    <span
                        key={`${label}-${i}`}
                        className="marquee-item text-3xl md:text-5xl lg:text-6xl"
                    >
                        {label}
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
